export default __webpack_public_path__ + "static/media/documents.9d8f5c8f.svg";